export const CUSTOMERS_LIST_LIMIT = 1000;
export const CUSTOMERS_PAGE_SIZE = 20;
export const columns = [
    {
        Header: 'Name',
        accessor: 'Name',
    },
    {
        Header: 'Email',
        accessor: 'Email',
    },
    {
        Header: 'Phone',
        accessor: 'Phone',
    },
    {
        Header: 'Address',
        accessor: 'Address',
    },
];
